// Dismissible nudge on the dashboard home for brand-new orgs — offers to
// start Fieldlink Guided Onboarding. Only shown when Super Admin has turned
// on "Auto-launch for new orgs" and this org hasn't started/dismissed it.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Sparkles, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export function GuidedOnboardingBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    api.get("/guided-onboarding/sessions/active").then(({ data }) => {
      setShow(!!data.should_auto_launch);
    }).catch(() => {});
  }, []);

  const dismiss = () => {
    setShow(false);
    api.post("/guided-onboarding/auto-launch-dismiss").catch(() => {});
  };

  if (!show) return null;

  return (
    <div className="flex items-center justify-between gap-4 bg-[#12161C] border border-[#FF5F15]/30 rounded-xl px-5 py-3.5 mb-5" data-testid="guided-onboarding-banner">
      <div className="flex items-center gap-3">
        <Sparkles className="w-5 h-5 text-[#FF5F15] shrink-0" />
        <p className="text-sm text-zinc-200">
          Want Kiri to walk you through setting up Fieldlink for your business?
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Link to="/app/onboarding" className="text-[11px] font-bold uppercase tracking-wider bg-[#FF5F15] hover:bg-[#E65100] text-white rounded-md px-3 py-1.5 flex items-center gap-1" data-testid="guided-onboarding-banner-start">
          Start Guided Onboarding <ArrowRight className="w-3.5 h-3.5" />
        </Link>
        <button onClick={dismiss} className="text-zinc-500 hover:text-white" data-testid="guided-onboarding-banner-dismiss" aria-label="Dismiss">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
